var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2A2A2A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14160_6824)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7607 10.3926C21.9438 10.3155 22.1441 10.2889 22.3409 10.3156C22.5377 10.3423 22.7238 10.4212 22.8798 10.5442C23.0357 10.6671 23.1558 10.8297 23.2277 11.0148C23.2995 11.2 23.3204 11.401 23.2881 11.597L21.6081 21.7874C21.4452 22.7703 20.3667 23.334 19.4652 22.8444C18.7111 22.4348 17.5911 21.8037 16.5837 21.1451C16.08 20.8155 14.537 19.76 14.7267 19.0089C14.8896 18.3666 17.4822 15.9533 18.9637 14.5185C19.5452 13.9548 19.28 13.6296 18.5933 14.1481C16.8874 15.4355 14.1504 17.3933 13.2452 17.9444C12.4467 18.4303 12.0304 18.5133 11.5326 18.4303C10.6244 18.2792 9.78221 18.0451 9.0948 17.76C8.16591 17.3748 8.2111 16.0977 9.09406 15.7259L21.7607 10.3926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14160_6824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7778,
    height: 17.7778,
    fill: "white",
    transform: "translate(7.11111 7.11108)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramGray);
export default __webpack_public_path__ + "static/media/telegram-gray.7c4eb6ea259b92a23ebdd8b3bde12f8e.svg";
export { ForwardRef as ReactComponent };